import React from "react";
import { data } from "../../constants";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { motion } from "framer-motion";
import { BsInstagram, BsWhatsapp, BsLinkedin } from "react-icons/bs";
import { FaPhoneAlt, FaEnvelope,FaCalendarAlt } from "react-icons/fa";
import "./Menu.css";
import { gtagSendEvent } from "../../utils/gtaghelper";

const Menu = () => {
  return (
    <motion.div
      initial={{ y: -100, x: "0%", opacity: 0 }}
      animate={{ y: 0, x: "0%", opacity: 1 }}
    >
<div
  className="banner"
  style={{
    backgroundColor: "#B9FF66",
    color: "black",
    textAlign: "center",
    padding: "10px 20px",
    fontWeight: 500,
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "10px",
    }}
  >
    {/* LEFT — Value prop */}
    <div style={{ fontWeight: 800}}>
     Trusted by 100+ businesses
    </div>

    {/* CENTER — Email */}
    <div>
      <a
        style={{ textDecoration: "none", color: "black" }}
        href="mailto:hello@quantech.pro"
      >
        <FaEnvelope /> &nbsp; hello@quantech.pro
      </a>
    </div>

    {/* RIGHT — CTA */}
    <div>
      <a
        style={{
          textDecoration: "none",
          color: "black",
          fontWeight: 600,
        }}
        href="#quote"
      >
        <FaCalendarAlt /> &nbsp; Book a Call
      </a>
    </div>
  </div>
</div>
      <Navbar collapseOnSelect expand="lg" bg="ligth" variant="ligth">
        <Container>
          <Navbar.Brand href="/#home">
            <h1
              style={{
                fontSize: "50px",
                textDecorationColor: "#b9ff66",
                textDecorationLine: "underline",
              }}
            >
              Quantech
            </h1>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              {data.Menu.map((item, index) => (
                <Nav.Link key={index} href={item.link}>
                  {item.text}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
};

export default Menu;
